import React from 'react';

const AddActionButton = (props) => {
  function handleClick(event) {
    event.preventDefault();
    props.onAdd();
  }

  return (
    <button
      className="button primary small add-action-button"
      onClick={event => handleClick(event)}
    >
      <i className="fa fa-check" />
      {props.label && <span>{props.label}</span>}
    </button>
  );
};

export default AddActionButton;
